export default __webpack_public_path__ + "static/media/thunder.bee1fb88.svg";